<template>
  <div id="app">
    <ElhubPage />
  </div>
</template>

<script>

  // External dependencies
  import Globalize from 'globalize'
  import 'devextreme/localization/globalize/date'
  import 'devextreme/localization/globalize/number'
  import 'devextreme/localization/globalize/currency'
  import 'devextreme/localization/globalize/message'
  import supplemental from 'devextreme-cldr-data/supplemental.json'
  import nbCldrData from 'devextreme-cldr-data/nb.json'

  // Pages
  import ElhubPage from './components/pages/ElhubPage'

  export default {
    name: 'app',
    components: {
      ElhubPage
    },
    data() {
      return {
        userInfo: null
      }
    },
    beforeCreate () {
      Globalize.load(supplemental, nbCldrData);
      Globalize.locale('nb');
    }
  }
</script>

<style>
  #app {
    font-family:             'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing:  antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding:                 0 100px;
    color:                   #2c3e50;
  }
</style>
